// 2025-04-03 根据 Google 技术客服咨询:  Google 分析和广告, 分析和广告的代码是可以重复添加的, 每个产品可以添加多个.

import { getConfig } from '../configProvider';

// 分析
export const ANALYSIS_CODE_XDESIGN = 'G-LDF9DCVPET'; // xd
export const ANALYSIS_CODE_DESIGNKIT_INTL = 'G-L7N9ED4WNY'; // designkit-intl
export const ANALYSIS_CODE_CUTOUT_GLOBAL = 'G-M0T0NSY5E3'; // cutout-global-intl
export const ANALYSIS_CODE = 'G-D7N7VW87WQ'; // 国内

// 代码根据引入的配置决定使用哪个代码进行统计
export const getAnalysisCode = () => {
    const { appName, isIntl, isCutoutGlobal } = getConfig();
    // 抠图
    if (isCutoutGlobal) return ANALYSIS_CODE_CUTOUT_GLOBAL;

    if (appName === 'designkit') return isIntl ? ANALYSIS_CODE_DESIGNKIT_INTL : ANALYSIS_CODE;

    // 打印错误情况，警告
    if (appName !== 'x-design') {
        console.warn(`The app name is incorrect; the current value is: ${appName}`);
    }

    // 兜底海外，这个也同下
    if (isIntl) return ANALYSIS_CODE_XDESIGN;

    // 兜底下，因为目前像 live-ppt 等其他项目并没有设置 appName
    return ANALYSIS_CODE;
};
